<template>
  <page :title="i18n.title">
    <div class="profile-warp">
      <div class="profile-row">
        <input type="text" v-model="firstName" :placeholder="i18n.firstName" />
      </div>
      <div class="profile-row">
        <input type="text" v-model="lastName" :placeholder="i18n.lastName" />
      </div>
      <div class="profile-row">
        <input type="email" v-model="email" :placeholder="i18n.email" />
      </div>
      <div class="btn profile-btn" @click="saveUserInfo">{{ i18n.save_change }}</div>
    </div>
  </page>
</template>

<script>
import { mapState } from "vuex"
import { USER_INFO } from "@/apis/user.js"

export default {
  computed: {
    ...mapState(["user"]),
    i18n() {
      return this.$t("profile")
    },
    i18nMsg() {
      return this.$t("msg")
    }
  },
  data() {
    return {
      email: '',
      firstName: '',
      lastName: ''
    }
  },
  methods: {
    loadUser() {
      this.$loading(true)
      this.$get(
        USER_INFO,
        {},
        (res) => {
          this.$loading(false)
          if (res.user) {
            this.$store.commit("user", res.user)
            this.$toast(this.i18nMsg.success)
            this.$router.go(-1)
          }
        },
        (err) => {
          this.$loading(false)
          this.$toast(err)
        }
      )
    },
    saveUserInfo() {
      this.$loading(true)
      this.$post(
        USER_INFO,
        {
          email: this.email,
          firstName: this.firstName,
          lastName: this.lastName
        },
        (res) => {
          this.$loading(false)
          this.loadUser()
        },
        (err) => {
          this.$loading(false)
          this.$toast(err)
        },
        {
          "headers": {
            "Content-Type": "application/json"
          }
        }
      )
    }
  },
  created() {
    this.email = this.user.email
    this.firstName = this.user.firstName
    this.lastName = this.user.lastName
  }
}
</script>

<style lang="less" scoped>
.profile-warp {
  padding: 56px;
  .profile-row {
    margin: 36px 0;
    height: 100px;
    display: flex;
    justify-content: flex-start;
    align-items: center;
    // border: 4px solid D5D5D5;
    background: #F8F6FC;
    border-radius: 20px;
    padding: 0 20px;

    input {
      font-size: 32px;
      width: 300px;
      flex: 1;
      height: 80px;
      padding: 0 20px;
      margin: 0;
      border: none;
      outline: none;
      background-color: rgba(0, 0, 0, 0);
    }
  }
  .profile-btn {
    margin-top: 160px;
  }
}
</style>
